import { pushFBEvent, pushGoogleTag } from './common';


export const PLANS = {
  'fl-1-month-intro-franko': {
    name: 'fl-1-month-intro-franko',
    price: 9.99,
    periodPrice: 9.99,
    description: 'one week trial',
    productId: '1 month - $9.99',
    duration: '1 month',
  },

  'fl-1-month-tomato': {
    name: 'fl-1-month-tomato',
    price: 19.96,
    periodPrice: 19.96,
    description: 'one month',
    productId: '1 month - $19.96',
    duration: '1 month',
  },

  'fl-3-month-garlic': {
    name: 'fl-3-month-garlic',
    price: 35.88,
    periodPrice: 35.88,
    description: 'three months',
    productId: '3 months - $35.88',
    duration: '3 months',
  },

  'fl-monthly-intro7d-10-1996': {
    name: 'fl-monthly-intro7d-10-1996',
    price: 19.96,
    periodPrice: 1,
    description: 'one week trial',
    productId: '1 month - $19.96',
    duration: '1 month',
  },

  'fl-monthly-intro7d-50-1996': {
    name: 'fl-monthly-intro7d-50-1996',
    price: 19.96,
    periodPrice: 5,
    description: 'one week trial',
    productId: '1 month - $19.96',
    duration: '1 month',
  },

  'fl-monthly-intro7d-100-1996': {
    name: 'fl-monthly-intro7d-100-1996',
    price: 19.96,
    periodPrice: 10,
    description: 'one week trial',
    productId: '1 month - $19.96',
    duration: '1 month',
  },

  'fl-monthly-intro7d-1651-1996': {
    name: 'fl-monthly-intro7d-1651-1996',
    price: 19.96,
    periodPrice: 16.51,
    description: 'one week trial',
    productId: '1 month - $19.96',
    duration: '1 month',
  },
};

const UPSELL_PRODUCT = {
  name: 'fl-monthly-driver-sos-skovoroda',
  price: 9.99,
  quantity: 1
};

export const setMetrics = (plan, id, isUpsell = false, referer = '', eventId) => {
    const price = PLANS[plan].price;
    const upsellPrice = UPSELL_PRODUCT.price;

    const items = isUpsell
        ? [
            {
                item_name: UPSELL_PRODUCT.name,
                item_id: UPSELL_PRODUCT.name,
                item_price: upsellPrice,
                quantity: 1,
                item_coupon: ''
            }
        ]
        : [
            {
                item_name: PLANS[plan].name,
                item_id: PLANS[plan].name,
                item_price: price,
                quantity: 1,
                item_coupon: ''
            }
        ];

    const gaData = {
        transaction_id: id,
        affiliation: 'Onboarding Store',
        value: isUpsell ? upsellPrice : price,
        tax: 0,
        shipping: 0,
        currency: 'USD',
        coupon: '',
        items
    };

    const setFbData = type => {
        return {
            value: type === 'upsell' ? upsellPrice : price,
            currency: 'USD',
            content_type: type,
            content_name: referer,
            subscription_sid: id,
        }
    };

    const fbData = setFbData('paid_subscription');
    const upsellFbData = setFbData('upsell');

    pushFBEvent(fbData,eventId);
    pushGoogleTag('purchase',gaData);
    if (isUpsell) pushFBEvent(upsellFbData,`${eventId}_upsell`);
};